import { render } from "./BecomeAmbassador.vue?vue&type=template&id=22fc0d79"
import script from "./BecomeAmbassador.vue?vue&type=script&lang=js"
export * from "./BecomeAmbassador.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__